export const PHONE_NUMBER_INCORRECT = 'PHONE_NUMBER_INCORRECT'
export const INVALID_REVISION = 'INVALID_REVISION'
